import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorDefaultConfig,
  ProsemirrorDefaultConfigDirective,
  WysiwygComponent,
} from '@core/prosemirror-legacy/webapp';
import type { EditorJSONState } from '@core/prosemirror-types';
import { BoxComponent, FormFieldComponent, HeadingComponent } from '@core/user-interface-legacy';
import { RequisitionOnlyIconComponent } from '@recruitee/requisitions-ui';

@Component({
  selector: 'rt-requisitions-context-form',
  templateUrl: './requisitions-context-form.component.html',
  styleUrls: ['./requisitions-context-form.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BoxComponent,
    FormFieldComponent,
    HeadingComponent,
    TranslatePipe,
    ReactiveFormsModule,
    WysiwygComponent,
    RenderDirective,
    ProsemirrorDefaultConfigDirective,
    RequisitionOnlyIconComponent,
  ],
})
export class RequisitionsContextFormComponent {
  public readonly generalContextControl = input<FormControl<EditorJSONState | object | null>>(
    undefined!,
  );
  public readonly isFormEditable = input<boolean>(undefined!);

  public ProsemirrorConfig = ProsemirrorDefaultConfig;
}
